
import React, { useState, useEffect } from 'react';
import './MainPanel.css'; // Reusing existing styles for consistency

const MAX_BATCH_SIZE = 5;

const ExportAttachmentsModal = ({ isOpen, onClose, parts, onExport }) => {
  const [selectedParts, setSelectedParts] = useState([]);
  const [formats, setFormats] = useState({ STEP: false, PDF: false });

  // Reset selection when modal opens
  useEffect(() => {
    if (isOpen) {
      setSelectedParts([]);
      setFormats({ STEP: false, PDF: false });
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handlePartToggle = (part) => {
    if (selectedParts.find(p => p.id === part.id)) {
      setSelectedParts(selectedParts.filter(p => p.id !== part.id));
    } else {
      if (selectedParts.length >= MAX_BATCH_SIZE) {
        alert(`You can only select up to ${MAX_BATCH_SIZE} items at a time.`);
        return;
      }
      setSelectedParts([...selectedParts, part]);
    }
  };

  const handleFormatToggle = (format) => {
    setFormats({ ...formats, [format]: !formats[format] });
  };

  const handleSubmit = () => {
    const selectedFormatList = Object.keys(formats).filter(k => formats[k]);
    onExport(selectedParts, selectedFormatList);
  };

  const isExportDisabled = selectedParts.length === 0 || (!formats.STEP && !formats.PDF);

  return (
    <div className="modal-backdrop">
      <div className="modal-content" style={{ maxWidth: '650px' }}>
        <div className="modal-header">
          <h3 className="modal-title">Export Attachments to Propel</h3>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        
        <div className="modal-body">
          <div className="info-box" style={{ maxWidth: '100%', marginBottom: '15px' }}>
            <p style={{ margin: 0 }}>
              Select up to <strong>{MAX_BATCH_SIZE}</strong> items to export. Files will be attached to the Propel Item.
            </p>
          </div>

          <div className="parts-list-section" style={{ maxHeight: '300px', overflowY: 'auto', marginTop: 0, borderTop: 'none' }}>
            <table className="parts-table">
              <thead>
                <tr>
                  <th style={{ width: '40px' }}>Select</th>
                  <th>Part Name</th>
                  <th>Part Number</th>
                </tr>
              </thead>
              <tbody>
                {parts.map(part => {
                  const isSelected = !!selectedParts.find(p => p.id === part.id);
                  const isDisabled = !isSelected && selectedParts.length >= MAX_BATCH_SIZE;
                  
                  return (
                    <tr key={part.id} className={isSelected ? 'selected-row' : ''}>
                      <td style={{ textAlign: 'center' }}>
                        <input
                          type="checkbox"
                          checked={isSelected}
                          disabled={isDisabled}
                          onChange={() => handlePartToggle(part)}
                        />
                      </td>
                      <td>{part.name}</td>
                      <td>{part.partNumber || '-'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {parts.length === 0 && <div className="empty-text">No eligible parts found.</div>}
          </div>

          <div style={{ marginTop: '20px', borderTop: '1px solid #eee', paddingTop: '15px' }}>
            <h4 style={{ fontSize: '0.95rem', marginBottom: '10px' }}>Select Formats</h4>
            <div style={{ display: 'flex', gap: '20px' }}>
              <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={formats.STEP}
                  onChange={() => handleFormatToggle('STEP')}
                  style={{ marginRight: '8px' }}
                />
                STEP (3D)
              </label>
              
              <div className="tooltip">
                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    checked={formats.PDF}
                    onChange={() => handleFormatToggle('PDF')}
                    style={{ marginRight: '8px' }}
                  />
                  PDF (2D)
                </label>
                <div className="tooltip-text" style={{ marginLeft: '5px', color: '#666', fontSize: '0.85rem' }}>
                  (Requires matching Drawing tab)
                </div>
              </div>
            </div>
          </div>

        </div>

        <div className="modal-actions">
          <button className="modal-button cancel" onClick={onClose}>Cancel</button>
          <button 
            className="modal-button submit" 
            onClick={handleSubmit} 
            disabled={isExportDisabled}
          >
            Export Files
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExportAttachmentsModal;
